import { render, staticRenderFns } from "./PCResult.vue?vue&type=template&id=0a1f33c6&scoped=true"
import script from "./PCResult.vue?vue&type=script&lang=js"
export * from "./PCResult.vue?vue&type=script&lang=js"
import style0 from "./PCResult.vue?vue&type=style&index=0&id=0a1f33c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f33c6",
  null
  
)

export default component.exports